import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class TaskSharedService {
    searchTitle = "";
    fromDate = null;
    toDate = null;
}